import data from './products.json';

// ─── Internal helpers ───

const getSegment = (id) => data.segments.find((s) => s.id === id);

// ─── Catalog queries ───

export const getCatalog = (segmentId) => {
    const segment = getSegment(segmentId);
    return segment?.catalog || [];
};

// ─── Page queries ───

export const getHomePage = () => data.pages.home;

export const getIndrasonPage = () => getSegment('wires')?.brandPages?.indrason || null;

export const getOrbitStarPage = () => getSegment('lights')?.productPages?.orbitStar || null;

export const getNotFoundPage = () => data.pages.notFound;

// ─── Collection queries ───

export const getCollection = (segmentId) => {
    const segment = getSegment(segmentId);
    return segment?.collection || null;
};

// ─── Commerce ───

// Google requires marked-up prices to match prices shown on the page, so no price means no Offer.
export const buildOfferSchema = (price) => {
    if (!price) return undefined;
    const c = data.commerce;
    return {
        "@type": "Offer",
        "price": price,
        "priceCurrency": c.currency,
        "availability": c.availability,
        "priceValidUntil": c.priceValidUntil,
        "shippingDetails": c.shippingDetails,
        "hasMerchantReturnPolicy": c.returnPolicy
    };
};

// ─── Convenience: get everything a marketing page needs ───

export const getSegmentPageData = (segmentId) => {
    const segment = getSegment(segmentId);
    if (!segment) return null;

    return {
        seo: segment.seo,
        hero: segment.hero,
        featuresSection: segment.featuresSection,
        specsSection: segment.specsSection,
        buyingGuide: segment.buyingGuide,
        certifications: segment.certifications,
        faq: segment.faq,
        cta: segment.cta,
        series: segment.series,
        families: segment.families,
        structuredProducts: segment.structuredProducts,
        ...(segment.flagship && { flagship: segment.flagship }),
        ...(segment.secondary && { secondary: segment.secondary }),
        ...(segment.allModels && { allModels: segment.allModels })
    };
};

export const getCollectionPageData = (segmentId) => {
    const segment = getSegment(segmentId);
    if (!segment) return null;

    return {
        ...segment.collection,
        families: segment.families,
        catalog: segment.catalog,
        series: segment.series
    };
};
